(function($){
	$('.open-popup-link').magnificPopup({
		type: 'inline',
		// modal: true,
		closeOnBgClick: false,
		closeOnContentClick: false,
		showCloseBtn: true,
		closeBtnInside: true,
		enableEscapeKey: false,
		callbacks: {
			open: function() {
				console.log('Modal Opened')
			},
			close: function() {
				console.log('Modal Closed')
			}
		}
	});
})(jQuery);
